export enum AppRoutes {
  Home = '/',

  // Authentication
  SignIn = '/sign-in',
  SignOut = '/sign-out',
  RegisterInvite = '/register/:token',
  ResetPassword = '/reset-password/:token',
  ForgotPassword = '/forgot-password',

  // User
  MyProfile = '/my-profile',

  // Admin
  Admin = '/admin',
  AdminCompanies = '/admin/companies',
  AdminCompanyDetails = '/admin/companies/:id',

  // Company settings
  MyCompanyDetails = '/my-company',

  // Folders
  // MyFolder = '/my-folder',

  // Common
  Error = '/error',
  NotFound = '*',

  // Solutions - PPA
  PPA = '/ppa', // Redirects to Home
  PPADetails = '/ppa/:id',

  // CGU
  ppaCguID = '/ppa/:id/cgu/:cguId',
  ppaCguOverview = '/ppa/:id/cgu/overview',

  // Consideration
  ppaConsideration = '/ppa/:id/consideration',
  ppaConsiderationEarnOut = '/ppa/:id/consideration/earn-out/:earnOutId',
  ppaConsiderationDeferredPayment = '/ppa/:id/consideration/deferred-payment/:deferredPaymentId',
  ppaConsiderationOverview = '/ppa/:id/consideration/overview',

  // DCF
  ppaDcf = '/ppa/:id/dcf',
  ppaDcfForm = '/ppa/:id/dcf/:modelInputId',
  ppaDcfInput = '/ppa/:id/dcf/:modelInputId/input',
  ppaDcfResults = '/ppa/:id/dcf/:modelInputId/results',

  // Intangible assets
  ppaIntangibleAssets = '/ppa/:id/intangibles',
  ppaIntangibleAsset = '/ppa/:id/intangibles/:intangibleAssetId',
  ppaIntangibleAssetGeneral = '/ppa/:id/intangibles/:intangibleAssetId/general',
  ppaIntangibleAssetInput = '/ppa/:id/intangibles/:intangibleAssetId/input',
  ppaIntangibleAssetResults = '/ppa/:id/intangibles/:intangibleAssetId/results',
  ppaIntangibleAssetWorkforceValuation = '/ppa/:id/intangibles/:intangibleAssetId/workforce-valuation',

  // RFR
  ppaRfr = '/ppa/:id/rfr/:modelInputId',
  ppaRfrInput = '/ppa/:id/rfr/:modelInputId/input',
  ppaRfrOutput = '/ppa/:id/rfr/:modelInputId/output',

  // MEEM
  ppaMeem = '/ppa/:id/meem/:modelInputId',
  ppaMeemInput = '/ppa/:id/meem/:modelInputId/input',
  ppaMeemOutput = '/ppa/:id/meem/:modelInputId/output',

  // PPA Outputs
  ppaFairValue = '/ppa/:id/fair-value',
  ppaIrrWara = '/ppa/:id/irr-wara',
  ppaReport = '/ppa/:id/report',
}
